import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import MfaChallenge from '../components/auth/MfaChallenge';

const MfaChallengePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tempToken = searchParams.get('tempToken');
  const oauth = searchParams.get('oauth'); // 'google' or null

  useEffect(() => {
    // For OAuth logins, always use httpOnly cookies
    if (oauth) {
      authService.useCookies = true;
    }
  }, [oauth]);

  const handleSuccess = () => {
    // After successful MFA verification, redirect to dashboard
    navigate('/dashboard');
  };

  const handleError = (error) => {
    // On error, redirect back to login
    console.error('MFA verification failed:', error);
    navigate('/login?error=mfa_failed');
  };

  if (!tempToken) {
    return (
      <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
        <h2>Invalid Session</h2>
        <p>The MFA session has expired or is invalid. Please log in again.</p>
        <button onClick={() => navigate('/login')} style={{
          padding: '12px 24px',
          backgroundColor: '#667eea',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 600,
          marginTop: '16px'
        }}>
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <MfaChallenge
      tempToken={tempToken}
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default MfaChallengePage;

